// @flow @format
import React from 'react';
import PropTypes from 'prop-types';
import PlayIcon from '../../../../components/Icon/play-circle-o';
import PauseIcon from '../../../../components/Icon/pause-circle-o';
import LoadingIcon from '../../../../components/Icon/circle-o-notch';
import ProgressBar from '../../../../components/ProgressBar';
import {toSIString} from 'lib/util';
import {
	DOWNLOAD_COMPLETED_STATUS,
	DOWNLOAD_RETRY_STATUS,
	DOWNLOAD_SETUP_STATUS,
	DOWNLOAD_FAILED_STATUS,
	DOWNLOAD_RUNNING_STATUS,
	DOWNLOAD_PAUSING_STATUS,
	DOWNLOAD_PAUSED_STATUS,
} from 'lib/downloader';
import './DownloadProgress.css';

import type {DownloadSummary} from 'lib/downloader';

type Props = {
	download: ?DownloadSummary,
	throughput: number,
	startDownload: (id: string) => void,
	pauseDownload: (id: string) => void,
	toggleHistory: () => void,
};

const DownloadProgress = ({
	download,
	throughput,
	startDownload,
	pauseDownload,
	toggleHistory,
}: Props) => {
	if (!download) {
		return null;
	}

	const {id, status, owner, filename, downloaded, size} = download;
	const completedPercentage = downloaded / size * 100;

	return (
		<div className="DownloadProgress">
			<ActionArea
				status={status}
				onClick={() => {
					if (
						status === DOWNLOAD_RUNNING_STATUS ||
						status === DOWNLOAD_RETRY_STATUS
					) {
						pauseDownload(id);
						return;
					}
					if (status === DOWNLOAD_PAUSED_STATUS) {
						startDownload(id);
						return;
					}
				}}
			/>
			<div className="DownloadProgress__InfoArea">
				<div className="DownloadProgress__InfoTextArea">
					<div className="DownloadProgress__InfoTextArea__Item">
						<p className="DownloadProgress__InfoTextArea__Text">
							<b>{filename}</b> - {owner}
						</p>
					</div>

					<div className="DownloadProgress__InfoTextArea__Item">
						<p className="DownloadProgress__InfoTextArea__Text DownloadProgress__InfoTextArea__Text--Status">
							{status === DOWNLOAD_RETRY_STATUS && (
								<span>
									<LoadingIcon className="rotate-animation" />{' '}
									<span>Reintentando ...</span>
								</span>
							)}
							{status !== DOWNLOAD_RETRY_STATUS && (
								<span>
									{toSIString(downloaded)}/{toSIString(size)}{' '}
									<b>
										({completedPercentage.toFixed(2)}%)
									</b>{' '}
									{toSIString(throughput, 'b')}/s
								</span>
							)}
						</p>
					</div>
				</div>

				<ProgressBar
					className="DownloadProgress__InfoArea__ProgressBar"
					completed={completedPercentage}
				/>
			</div>
		</div>
	);
};

DownloadProgress.propTypes = {
	download: PropTypes.object,
	startDownload: PropTypes.func.isRequired,
	pauseDownload: PropTypes.func.isRequired,
	toggleHistory: PropTypes.func.isRequired,
};

const statusButtons = {
	[DOWNLOAD_COMPLETED_STATUS]: null,
	[DOWNLOAD_FAILED_STATUS]: null,
	[DOWNLOAD_RETRY_STATUS]: (
		<PauseIcon className="DownloadProgress__ActionArea__Button" />
	),
	[DOWNLOAD_SETUP_STATUS]: (
		<LoadingIcon className="DownloadProgress__ActionArea__Icon rotate-animation" />
	),
	[DOWNLOAD_PAUSING_STATUS]: (
		<LoadingIcon className="DownloadProgress__ActionArea__Icon rotate-animation" />
	),
	[DOWNLOAD_RUNNING_STATUS]: (
		<PauseIcon className="DownloadProgress__ActionArea__Button" />
	),
	[DOWNLOAD_PAUSED_STATUS]: (
		<PlayIcon className="DownloadProgress__ActionArea__Button" />
	),
};

const ActionArea = ({status, onClick}) => {
	const icon = statusButtons[status];
	if (!icon) {
		return null;
	}

	return (
		<div className="DownloadProgress__ActionArea">
			<icon.type {...icon.props} onClick={onClick} />
		</div>
	);
};

export default DownloadProgress;



// WEBPACK FOOTER //
// ./src/routes/Explorer/components/DownloadProgress/DownloadProgress.js